export default "__VITE_ASSET__Bf548NYI__"